import { Component, OnInit } from '@angular/core';
import { WgisService } from '../wgis/wgis.service';

@Component({
  selector: 'app-credit',
  templateUrl: './credit.component.html',
})
export class CreditComponent implements OnInit {

  constructor(
    private wgisservice: WgisService
  ) {
    this.wgisservice.setMapInvisible();
  }

  ngOnInit() {
  }

}
